import React, { Component } from "react";
import TreeAndTableLayout from "../../../../components/TreeAndTableLayout/TreeAndTableLayout";
import BaseComponent from "../../../../base/BaseComponent";
import { filterForEach, generateTreeData, treeForEach } from "../../../../utils";
import MenuToolBar from "./menuToolBar/MenuToolBar";
import MenuTableOperation from "./menuTableOperation/MenuTableOperation";
import MenuEditModal from "./menuEditModal/MenuEditModal";
import BoundPermissionModal from "../permission/boundPermissionModal/BoundPermissionModal";
import {message} from 'antd';
// import {message} from "../../utils/sysManagementUtils";
import ContentWrap from "../../components/ContentWrap";
import Titlepicfile from "../../../components/titlepicfile/Titlepicfile";
import $ from "jquery";
import {InputNumber} from "antd";

export default class MenuList extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            treeData: [],
            treeDataIndex: {
                id: "id",
                title: "menuName",
                children: "child",
                key: "id",
                label: "menuName"
            },
            selectedKeys: [],
            pageSize: 10,
            currentPage: 1,
            columns: [],
            count: 0,
            tableData: [],
            tableIsLoading: false,
            searchValue: "",
            expandedKeys: [],
            autoExpandParent: true,

            menuEditModalVisible: false,
            editMenu: null,
            bindPermissionVisible: false,
            editBindPermission: null,
            isUpdateSort: false
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.mediaId = nextProps.match.params.mediaId ? nextProps.match.params.mediaId : '';
        this.setState({},() => {
            this.getTableData();
            this.getTreeData();
            this.getColumns();
        })
    }

    componentDidMount() {
        this.getTableData();
        this.getTreeData();
        this.getColumns();
    }

    render() {
        const {
            selectedKeys,
            treeData,
            pageSize,
            currentPage,
            columns,
            count,
            tableData,
            tableIsLoading,
            searchValue,
            expandedKeys,
            autoExpandParent,
            menuEditModalVisible,
            editMenu,
            editBindPermission,
            bindPermissionVisible
        } = this.state;
        return (
            <ContentWrap>
                <TreeAndTableLayout
                    showIcon={true}
                    selectedKeys={selectedKeys}
                    treeData={treeData}
                    expandedKeys={expandedKeys}
                    onExpand={this.onExpand}
                    autoExpandParent={autoExpandParent}
                    onSelect={this.onTreeSelect}
                    pageSize={pageSize}
                    current={currentPage}
                    columns={columns}
                    count={count}
                    tableData={tableData}
                    tableIsLoading={tableIsLoading}

                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}

                    ToolBar={
                        <MenuToolBar
                            searchValue={searchValue}
                            onSearchValueChange={searchValue => this.setState({ searchValue })}
                            onSearch={this.onSearch}
                            showMenuEdit={() => this.showMenuEdit({ fid: selectedKeys[0] })}
                            showBoundPermission={this.showBoundPermission}
                            isRootNode={this.isRootNode}
                            tableData={this.state.tableData}
                            sortStatusCall={() => {
                                this.setState({isUpdateSort: !this.state.isUpdateSort})
                            }}
                            onSortCall={() => {
                                this.getTreeData();
                                this.getTableData();
                                this.hideMenuEdit();
                            }}
                        />
                    }
                />
                <MenuEditModal
                    visible={menuEditModalVisible}
                    data={editMenu}
                    handleCancel={this.hideMenuEdit}
                    handleOk={this.submitMenuEdit}
                />

                <BoundPermissionModal
                    visible={bindPermissionVisible}
                    data={editBindPermission}
                    handleCancel={this.hideBoundPermission}
                    handleOk={this.submitBoundPermission}
                />
            </ContentWrap>
        );
    }

    isRootNode = () => {
        const { selectedKeys } = this.state;
        return selectedKeys[0] === "0";
    };
    hideBoundPermission = () => {
        this.setState({
            editBindPermission: null,
            bindPermissionVisible: false
        });
    };

    showBoundPermission = () => {
        const { selectedKeys, treeData } = this.state;
        const currentSelect = selectedKeys[0];
        if (currentSelect === "0" || !currentSelect) {
            return message.error("根菜单（全部）下不能添加权限，请重新选择菜单");
        }
        let data = {};
        treeForEach(treeData, node => {
            if (node.id === currentSelect) {
                data = node;
            }
        });
        this.findPermissionListByMenuIdRequest(currentSelect, res => {
            this.setState({
                editBindPermission: res,
                bindPermissionVisible: true
            });
        });
    };

    submitBoundPermission = permissionList => {
        message.destroy();
        if(!permissionList || !permissionList.length>0){
            return message.info("请先选择权限");
        }
        const { selectedKeys } = this.state;
        const menuId = selectedKeys[0] || "0";
        this.boundPermissionRequest({ menuId, permissionList }, res => {
            message.success("权限绑定成功");
            this.getTreeData();
            this.getTableData();
            this.hideBoundPermission();
        });
    };

    hideMenuEdit = () => {
        this.setState({
            menuEditModalVisible: false,
            editMenu: null
        });
    };

    showMenuEdit = editMenu => {
        this.setState({
            menuEditModalVisible: true,
            editMenu
        });
    };

    submitMenuEdit = data => {
        message.destroy();
        if (data.id) {
            this.editMenu(data);
        } else {
            this.addMenu(data);
        }
    };

    onSearch = () => {
        this.setState({
            currentPage: 1
        }, () => {
            this.getTableData();
        });
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    expandKey = key => {
        const { expandedKeys, treeData } = this.state;
        const tree = filterForEach(treeData, node => {
            return node.id === key;
        });
        const keys = [];
        treeForEach(tree, node => {
            keys.push(node.id);
        });
        this.setState({
            expandedKeys: [...(new Set([...expandedKeys, ...keys]))],
            autoExpandParent: false
        });
    };
    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = (page, pageSize) => {
        this.setState({
            currentPage: page,
            pageSize: pageSize
        }, () => {
            this.getTableData();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = (current, size) => {
        this.setState({
            pageSize: size,
            currentPage: 1
        }, () => {
            this.getTableData();
        });
    };

    onTreeSelect = (selectKeys, e) => {
        this.setState({
            currentPage: 1,
            selectedKeys: selectKeys,
            searchValue: ""
        }, () => {
            this.getTableData();
        });
    };

    getTreeData = () => {
        const { selectedKeys, treeDataIndex } = this.state;
        this.findMenuTreeRequest(res => {
            // 格式化树数据
            const treeData = generateTreeData([res], this.state.treeDataIndex);
            // 首次请求设置激活的树id  并展开所有的树
            if (!selectedKeys.length) {
                const expandedKeys = [];
                treeForEach(treeData, node => {
                    if (node.children && node.children.length) {
                        expandedKeys.push(node.id);
                    }
                });
                this.setState({
                    selectedKeys: [treeData[0].id],
                    expandedKeys,
                    treeData
                });
            }
            this.setState({
                treeData
            });
        });
    };

    getTableData = () => {
        const { pageSize, currentPage: pageNum, selectedKeys, searchValue } = this.state;
        const menuId = selectedKeys[0] || "0";
        const params = { pageNum, pageSize, name: searchValue, code: searchValue, menuId };
        this.findListByConditionRequest(params, res => {
            const { count, data: tableData } = res;
            this.setState({
                count,
                tableData
            }, () => {
                $('.ant-pagination-options-quick-jumper').find('input').val('')
            });
        });
    };

    tableColumnIndex = {
        optionSort: "optionSort",
        code: "code"
    };

    getColumns = () => {
        const columns = [
            {
                title: "名称",
                dataIndex: "name",
                width: 180,
                ellipsis: true,
                render: (text, record) => {
                    let ico;
                    // 判断是显示移动端还是PC端ico
                    if (record.clientTypes && record.clientTypes.length === 1) {
                        if (record.clientTypes.indexOf(0) > -1) {
                            ico = record.ico
                        } else if (record.clientTypes.indexOf(1) > -1) {
                            ico = record.mobileIco
                        }
                    } else if (record.clientTypes && record.clientTypes.length > 1) {
                        if (record.clientTypes.indexOf(0) > -1) {
                            ico = record.ico
                        }
                    }
                    if (ico) {
                        return <div style={{
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <div
                                style={{
                                    flex: "0 0 18px",
                                    height: "18px",
                                    backgroundImage: `url(${ico})`,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    marginRight: "8px"
                                }}
                            >
                            </div>
                            <span>{text}</span>
                        </div>;
                    } else if (!(record.ico||record.mobileIco) && record.svg||record.mobileSvg) {
                        return (
                            <>
                                <div className={'iconStyle'} style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    <div style={{
                                        flex: "0 0 18px",
                                        height: "18px",
                                        width: "18px",
                                        marginRight: "8px"
                                    }}
                                         dangerouslySetInnerHTML={{__html: record.svg||record.mobileSvg}}
                                    />
                                    <span>{text}</span>
                                </div>
                                <style>{`
                                .iconStyle .icon{
                                    height: 18px !important;
                                    width: 18px !important;
                                    vertical-align: sub;
                                }
                                `}</style>
                            </>
                        )
                    } else {
                        return <span>{text}</span>;
                    }
                }
            },
            {
                title: "编码",
                dataIndex: this.tableColumnIndex.code,
                width: 180,
                ellipsis: true
            },
            {
                title: "类型",
                dataIndex: "type",
                width: 160,
                render: (text) => {
                    if (text === "1") {
                        return "菜单";
                    } else if (text === "2") {
                        return "权限";
                    }
                }
            },
            {
                title: "排序",
                dataIndex: this.tableColumnIndex.optionSort,
                ellipsis: true,
                width: 160,
                render: (text, record) => {
                    return (
                        <>
                            {this.state.isUpdateSort ?
                                <InputNumber style={{width: '60px'}} min={0} max={99999}
                                             parser={value => value.replace(/\D/g, '')}
                                             defaultValue={record[this.tableColumnIndex.optionSort] >= 0 ? record[this.tableColumnIndex.optionSort] : record.permissionSort >= 0 ? record.permissionSort : 10}
                                             onChange={(value) => this.onChangeNum(value, record)}/> :
                                <div>{record[this.tableColumnIndex.optionSort] >= 0 ? record[this.tableColumnIndex.optionSort] : record.permissionSort >= 0 ? record.permissionSort : 10}</div>
                            }
                        </>
                    )
                }
            },
            {
                title: "操作",
                width: 160,
                render: (text, record) => {
                    return <MenuTableOperation
                        data={record}
                        showMenuEdit={this.showMenuEdit}
                        deleteMenu={this.deleteMenu}
                        unboundPermissionByCode={this.unboundPermissionByCode}
                    />;
                }
            }
        ];
        this.setState({
            columns
        });
    };

    addMenu = data => {
        this.addMenuRequest(data, res => {
            message.success("菜单添加成功");
            this.setState({
                currentPage: 1
            }, () => {
                this.getTreeData();
                this.getTableData();
                this.hideMenuEdit();
                this.expandKey(data.fid);
            })
        });
    };

    editMenu = data => {
        this.editMenuRequest(data, (res) => {
            message.success("菜单修改成功");
            this.getTreeData();
            this.getTableData();
            this.hideMenuEdit();
        });
    };
    // 排序改变
    onChangeNum = (value, record) => {
        record[this.tableColumnIndex.optionSort] = value;
    };

    deleteMenu = data => {
        this.deleteMenuByIdRequest(data.id, () => {
            message.success("菜单已被删除");
            this.getTreeData();
            this.getTableData();
        });
    };

    unboundPermissionByCode = (data) => {
        const params = {
            permissisonId: data.id,
            menuId: this.state.selectedKeys[0]
        };
        this.unboundPermissionByCodeRequest(params, () => {
            message.success("权限解绑成功");
            this.getTableData();
            this.getTreeData();
        });
    };

    ////request    ///

    /**
     * 显示菜菜单信息
     * @param callBack
     */
    findMenuTreeRequest = callBack => {
        this.request({
            url: "/cm-sites-sys/menu/findMenuTree",
            callBack
        });
    };

    findListByConditionRequest = ({ pageNum, pageSize, name, code, menuId }, callBack) => {
        this.request({
            url: "/cm-sites-sys/menu/findListByCondition",
            body: {
                pageNum, pageSize, name, code, menuId
            },
            method: "post",
            contentType: "json",
            callBack: res => {
                const tableData = res.data;
                tableData && tableData.forEach(item => {
                    if (item.type === "1") {
                        item.code = item.menuCode;
                        item.name = item.menuName;
                    }
                });
                callBack(res);
            }
        });
    };

    addMenuRequest = ({ menuName, fid, path, mobilePath, ico, mobileIco, svg, mobileSvg, jumpType, isExpand, permissionList, menuCode, optionSort, clientTypes }, callBack) => {
        this.request({
            url: "/cm-sites-sys/menu/add",
            body: { menuName, fid, path,mobilePath, ico,mobileIco, svg, mobileSvg, jumpType, isExpand, permissionList, menuCode, optionSort, clientTypes },
            method: "post",
            contentType: "json",
            callBack
        });
    };

    editMenuRequest = ({ id, menuName, fid, path, mobilePath, ico, mobileIco, svg,mobileSvg, jumpType, clientTypes, isExpand, optionSort, permissionList }, callBack) => {
        this.request({
            url: "/cm-sites-sys/menu/edit",
            body: { id, menuName, fid, path, mobilePath, ico, mobileIco, svg, mobileSvg, jumpType, clientTypes, isExpand, optionSort, permissionList },
            method: "post",
            contentType: "json",
            callBack
        });
    };

    deleteMenuByIdRequest = (menuId, callBack) => {
        this.request({
            url: "/cm-sites-sys/menu/deleteById",
            body: { menuId },
            method: "post",
            callBack
        });
    };

    unboundPermissionByCodeRequest = ({ permissisonId, menuId = "0" }, callBack) => {
        this.request({
            url: "/cm-sites-sys/menu/unboundPermissionByCode",
            body: { menuId, permissisonId },
            method: "post",
            callBack
        });
    };

    boundPermissionRequest = ({ menuId, permissionList }, callBack) => {
        this.request({
            url: "/cm-sites-sys/menu/boundPermission",
            body: { menuId, permissionList },
            method: "post",
            contentType: "json",
            callBack
        });
    };

    findPermissionListByMenuIdRequest = (menuId = "0", callBack) => {
        this.request({
            url: "/cm-sites-sys/menu/findPermissionListByMenuId",
            body: { menuId },
            method: "post",
            callBack
        });
    };

}
